// 入口文件
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// polyfill

// 导入组件
import Vue from 'vue'
import App from './App'
import Login from './components/Login'
import Verify from './components/Verify'
import Uinput from './components/Uinput'
import Upwd from './components/Pwdinput'
import Button from './components/Button'
import Suggest from './components/Suggest'
import MbInput from './components/MbInput'
import Capture from './components/Capture'
import Loading from './components/Loading'
import Verifymb from './components/Verifymb'
import Verifyopt from './components/Verifyopt'
import Verifyluo from './components/Verifyluo'
import SmsUp from './components/SmsUp'
import Verifyppc from './components/Verifyppc'
import Toast from './components/Toast'
import Confirm from './components/Confirm'
import ErrorPage from './components/ErrorPage'
import Form from './components/Form'
import FormItem from './components/FormItem'
import preAccount from './components/preAccount'
import jumploading from './components/jumploading'
import mode from './components/mode'

// 导入依赖库
import util from './util/util'
import iconfont from './util/iconfont.js'


String.prototype.trim = function() {
    return this.replace(/(^\s*)|(\s*$)/g, '')
}
Vue.config.productionTip = false

// 注册全局组件
Vue.component('login', Login)
Vue.component('urs-input', Uinput)
Vue.component('urs-pwdinput', Upwd)
Vue.component('urs-button', Button)
Vue.component('verify', Verify)
Vue.component('verifymb', Verifymb)
Vue.component('verifyopt', Verifyopt)
Vue.component('suggest', Suggest)
Vue.component('urs-mbinput', MbInput)
Vue.component('urs-capture', Capture)
Vue.component('loading', Loading)
Vue.component('verifyluo', Verifyluo)
Vue.component('smsup', SmsUp)
Vue.component('verifyppc', Verifyppc)
Vue.component('toast', Toast)
Vue.component('confirm', Confirm)
Vue.component('errorpage', ErrorPage)
Vue.component('form-item', FormItem)
Vue.component('Form', Form)
Vue.component('pre-account', preAccount)
Vue.component('jumploading', jumploading)
Vue.component('mode', mode)

    /* eslint-disable no-new */
new Vue({
    el: '#app',
    template: '<App/>',
    components: { App }
})

// 全局loading
window.Loading = new Vue({
    el: '#loading',
    template: '<loading :loading="loading" />',
    data: {
        loading: true
    }
})

//通用成功跳转
window.jumpLoading = new Vue({
     el:'#jumpLoading',
     template:'<jumploading :loading="loading" />',
     data:{
       loading:false
     }
})


// 全局toast提示
window.Toast = new Vue({
    el: '#toast',
    template: '<toast ref="toast" />',
    methods: {
        show(cnt, time) {
            this.$refs.toast.show(cnt)
        }
    }
})

// 全局Confirm提示
window.Confirm = new Vue({
    el: '#confirm',
    template: '<confirm ref="confirm"/>',
    methods: {
        show(options) {
            this.$refs.confirm.show(options)
        }
    }
})

// 通用显示错误提示
window.showError = function(cnt) {
    // 未传入或传入undefined null
    if (!cnt) {
        window.Toast.show('未知错误，请刷新页面重试')
        return
    }
    // 只传入字符串，默认toast
    if (util.isTypeOf(cnt, 'string')) {
        window.Toast.show(cnt)
        return
    }
    // 传入对象，判断是toast还是confirm
    if (util.isObject(cnt)) {
        if (!cnt.type) return
        switch (cnt.type) {
            case 'toast':
                if (!cnt.msg) break;
                window.Toast.show(cnt.msg);
                break;
            case 'confirm':
                if (!cnt.opt) break;
                window.Confirm.show(cnt.opt);
                break;
            default:
                window.Toast.show('未知错误');
                break;
        }
    }
}





// WEBPACK FOOTER //
// ./src/main.js